@let countryPickerOpened = isCountryOverlayOpened() || isSheetOpened();

<p-inputgroup
  styleClass="inputgroup-addon {{ _disabled() ? 'disabled' : '' }} {{
    countryPickerOpened ? 'active' : ''
  }}"
>
  <p-inputgroup-addon
    [styleClass]="`h--${height()}`"
    class="clickable"
    (click)="openCountryOverlay()"
  >
    <span class="addon-label text-14 fw-400">
      {{ currentPrefix() }}
    </span>

    <app-icon-chevron
      height="16"
      width="16"
      [direction]="countryPickerOpened ? 'up' : 'down'"
    ></app-icon-chevron>
  </p-inputgroup-addon>

  <input
    #inputRef
    type="text"
    inputmode="numeric"
    pInputText
    class="h--{{ height() }}"
    [placeholder]="
      placeholderText() === undefined
        ? ('common.placeholders.enter-phone-number' | translate)
        : placeholderText()
    "
    [disabled]="_disabled()"
    [readonly]="useRecentsSheet()"
    (focus)="openAutocompleteOverlay()"
    (click)="useRecentsSheet() && openRecentsSheet()"
    appFormControlClasses
  />
</p-inputgroup>

<p-overlay
  #countriesOverlay
  [styleClass]="deviceService.isMobile() ? '' : 'mt-12'"
  [appendTo]="appendTo()"
  [visible]="isCountryOverlayOpened()"
  [target]="'@parent'"
  (onBeforeEnter)="scrollCountriesOverlayToSelectedOption()"
  (onHide)="isCountryOverlayOpened.set(false)"
>
  <ng-template #content>
    <div class="phone-number-input-overlay phone-options">
      <div class="scroll-wrapper scrollbar-gray">
        <ng-container
          [ngTemplateOutlet]="countryList"
          [ngTemplateOutletContext]="{ selectedCode: selectedCountryCode() }"
        ></ng-container>
      </div>
    </div>
  </ng-template>
</p-overlay>

@if (useMobileSheet()) {
  <app-bottom-dialog
    [visible]="isSheetOpened()"
    (visibleChange)="!$event && cancelSheet()"
    (placed)="scrollSheetToSelectedOption()"
  >
    <div class="sheet-content">
      @if (mobilePanelTitle()) {
        <div class="text-18 fw-600 color-gray-900 mb-16">{{ mobilePanelTitle() }}</div>
      }
      <div class="sheet-list phone-options">
        <header class="search-box">
          <p-iconfield>
            <input
              pInputText
              autocomplete="off"
              autocorrect="off"
              spellcheck="false"
              [ngModel]="searchCriteria()"
              [placeholder]="'button.search' | translate"
              (ngModelChange)="searchCriteria.set($event)"
            />

            <p-inputicon class="flex gap-4">
              @if (searchCriteria().length >= 1) {
                <app-icon-close
                  class="clickable"
                  (click)="searchCriteria.set('')"
                  [color]="'var(--color-gray-500)'"
                ></app-icon-close>
              }
              <app-icon-search [height]="20" [width]="20"></app-icon-search>
            </p-inputicon>
          </p-iconfield>
        </header>

        <div #sheetScrollWrapper class="scroll-wrapper scrollbar-gray">
          <ng-container
            [ngTemplateOutlet]="countryList"
            [ngTemplateOutletContext]="{ selectedCode: pendingCountryCode() }"
          ></ng-container>
        </div>
      </div>
      <footer class="flex gap-12 mt-16">
        <p-button class="h--40 text-14 fw-600 w50" [severity]="'secondary'" (click)="cancelSheet()">
          {{ 'button.cancel' | translate }}
        </p-button>
        <p-button
          class="h--40 text-14 fw-600 w50"
          [disabled]="!pendingCountryCode()"
          (click)="applySheet()"
        >
          {{ 'button.apply' | translate }}
        </p-button>
      </footer>
    </div>
  </app-bottom-dialog>
}

@if (useRecentsSheet()) {
  <app-autocomplete-sheet
    [suggestions]="recentsOptions()"
    [freeText]="true"
    [canCommitText]="recentsNumberValid()"
    [completeOnFocus]="true"
    [delay]="0"
    [heading]="mobilePanelTitle()"
    (searchChange)="recentsQuery.set(stripNonNumeric($event))"
    (optionTap)="markRecentOption($event)"
    (optionSelect)="selectAutocompleteOption($event)"
    (textCommit)="commitRecentsNumber()"
  >
    <ng-template #input>
      <p-inputgroup styleClass="inputgroup-addon">
        <p-inputgroup-addon styleClass="h--40">
          <span class="addon-label text-14 fw-400">{{ recentsPrefix() }}</span>
        </p-inputgroup-addon>
        <input
          #recentsInput
          type="text"
          inputmode="numeric"
          enterkeyhint="done"
          autocomplete="off"
          pInputText
          class="h--40"
          [placeholder]="
            placeholderText() === undefined
              ? ('common.placeholders.enter-phone-number' | translate)
              : placeholderText()
          "
          (input)="onRecentsInput(recentsInput)"
          (keydown.enter)="submitRecents($event)"
        />
      </p-inputgroup>
    </ng-template>

    @let title = autocompleteOverlayTitle();
    @if (title) {
      <ng-template #header>
        <header class="autocomplete-header">
          <div class="title text-10 fw-700 color-gray-500">{{ title }}</div>
        </header>
      </ng-template>
    }

    <ng-template #item let-option>
      <div class="text-14">{{ option.label }}</div>
    </ng-template>
  </app-autocomplete-sheet>
} @else if (autocompleteEnabled()) {
  @let autocompleteOptions = filteredAutocompleteOptions();
  <p-overlay
    #autocompleteOverlay
    [styleClass]="deviceService.isMobile() ? '' : 'mt-12'"
    [appendTo]="appendTo()"
    [visible]="isAutocompleteOverlayOpened()"
    [target]="'@parent'"
    (onHide)="isAutocompleteOverlayOpened.set(false)"
  >
    <ng-template #content>
      @if (autocompleteOptions.length) {
        <div class="phone-number-input-overlay phone-options">
          @let title = autocompleteOverlayTitle();
          @if (title) {
            <header class="autocomplete-header">
              <div class="title text-10 fw-700 color-gray-500">{{ title }}</div>
            </header>
          }

          <div class="scroll-wrapper scrollbar-gray">
            <div class="unpinned-options-list flex--col clickable">
              @for (option of filteredAutocompleteOptions(); track option.value) {
                <div
                  class="option-item"
                  [class.selected]="option.value === _value()"
                  (click)="selectAutocompleteOption(option)"
                >
                  <div class="text-wrapper text-14 color-gray-900">{{ option.label }}</div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </ng-template>
  </p-overlay>
}

<ng-template #countryList let-selectedCode="selectedCode">
  @let pinnedOptions = pinnedCountryOptions();
  @let unpinnedOptions = unpinnedCountryOptions();

  @if (pinnedOptions.length) {
    <div class="pinned-options-list flex--col clickable">
      @for (option of pinnedOptions; track option.value) {
        <div
          class="option-item"
          [class.selected]="option.value === selectedCode"
          (click)="pickCountry(option)"
        >
          <div class="prefix text-14 fw-500 color-gray-900 mr-8">
            {{ option.title }}
          </div>
          <div class="text-wrapper text-14">
            {{ option.label }}
          </div>
        </div>
      }
    </div>
  }

  @if (unpinnedOptions.length) {
    <div class="unpinned-options-list flex--col clickable">
      @for (option of unpinnedOptions; track option.value) {
        <div
          class="option-item"
          [class.selected]="option.value === selectedCode"
          (click)="pickCountry(option)"
        >
          <div class="prefix text-14 fw-500 color-gray-900 mr-8">
            {{ option.title }}
          </div>
          <div class="text-wrapper text-14">
            {{ option.label }}
          </div>
        </div>
      }
    </div>
  }

  @if (!pinnedOptions.length && !unpinnedOptions.length) {
    <p class="no-results-text text-12 color-gray-500">
      {{ 'common.no-results' | translate }}
    </p>
  }
</ng-template>
